import React from "react";
import FadeInWrapper from "./fade-in-wrapper";

class PerceivedLiftMetric extends React.PureComponent {
  render() {
    const { perceivedLift } = this.props;

    return (
      <div
        className={`d-flex align-items-center ${
          perceivedLift >= 0 ? "text-success" : "text-danger"
        }`}
      >
        {perceivedLift >= 0 ? (
          <div className="pr-1">
            <i
              className="fa fa-arrow-circle-o-up"
              style={{ fontSize: "18px" }}
              aria-hidden="true"
            ></i>
          </div>
        ) : (
          ""
        )}
        <FadeInWrapper key={perceivedLift}>
          <span style={{ fontWeight: "500" }}>
            {perceivedLift >= 0 ? "+" : "-"}
            {Math.abs(perceivedLift)}%
          </span>
        </FadeInWrapper>
      </div>
    );
  }
}

export default PerceivedLiftMetric;
